import {Component, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {IFebLocalisation} from 'src/app/shared/models/feb-localisation';
import {AuthenticationService} from 'src/app/shared/services/authentication.service';
import {DialogService} from 'src/app/shared/services/dialog.service';
import {ThemeService} from 'src/app/shared/services/theme.service';
import {SnackbarService} from 'src/app/shared/services/snackbar.service';
import {FebLocationsService} from './feb-locations.service';
import {ApplicationSettingsService} from '../application-settings/application-settings.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-feb-locations-management',
  templateUrl: './feb-locations-management.component.html',
  styleUrls: ['./feb-locations-management.component.less']
})
export class FebLocationsManagementComponent {

  localisations!: MatTableDataSource<IFebLocalisation>;
  localisationSelected!: IFebLocalisation;

  @ViewChild(MatSort)
  sort!: MatSort;

  displayedColumns: string[] = ['localisationLabel', 'actions'];

  constructor(
    public febLocationsService: FebLocationsService,
    public authenticationService: AuthenticationService,
    private dialogService: DialogService,
    public theme: ThemeService,
    private snackbarService: SnackbarService,
    private applicationSettingsService: ApplicationSettingsService,
    private router: Router
  ) {
    this.localisations = new MatTableDataSource();
    this.loadLocalisations();
  }

  openErrorSnackBar(message: string) {
    this.snackbarService.openSnackBar(message, 'error-snack-bar');
  }

  openSuccessSnackBar(message: string) {
    this.snackbarService.openSnackBar(message);
  }

  goBack(): void {
    this.router.navigate(['/core/admin/centre-competence']);
  }

  loadLocalisations(): void {
    this.febLocationsService.getAll().subscribe(value => {
      this.localisations.data = value;
    });
  }

  selectedLocalisation(localisation: IFebLocalisation): void {
    this.localisationSelected = { ...localisation, check: false };
  }

  selectedLocalisationPencil(localisation: IFebLocalisation): void {
    this.localisationSelected = { ...localisation, check: false };
  }

  initLocalisation(): void {
    this.localisationSelected = {
      id: '',
      localisationLabel: '',
      check: false
    };
  }

  ngAfterViewInit(): void {
    this.localisations.sort = this.sort;
  }

  updateLocalisationList(updated?: IFebLocalisation): void {
    if (updated?.id) {
      const index = this.localisations.data.findIndex(l => l.id === updated.id);
      if (index !== -1) {
        const newData = [...this.localisations.data];
        newData[index] = updated;
        this.localisations.data = newData;
        return;
      }
    }
    this.loadLocalisations();
  }

  removeLocalisation(row: IFebLocalisation): void {
    this.dialogService.openConfirmDialog(row.localisationLabel ?? '')
      .afterClosed().subscribe({
        next: res => {
          if (res) {
            this.febLocationsService.delete(row).subscribe({
              next: () => {
                this.loadLocalisations();
                this.initLocalisation();
                this.snackbarService.openSnackBar('La localisation a été supprimée avec succès');
              },
              error: () => {
                this.snackbarService.openSnackBar('Une erreur est survenue lors de la suppression de la localisation', 'error-snack-bar');
              }
            });
          }
        }
      });
  }

  localisationsFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.localisations.filter = filterValue.trim().toLowerCase();
  }

  exportData() {
      this.febLocationsService.exportFebLocationsData().subscribe({
        next: (data) => {
          if (data) {
            const blob: Blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            window.URL.createObjectURL(blob);
            fileSaver.saveAs(
              blob,
              'Localisations FEB - ' +
              this.applicationSettingsService.applicationSettings.CDS_name +
              ' - ' +
              new Date().toLocaleDateString().replace('_', '-') +
              ' ' +
              new Date().toLocaleTimeString().replace('_', '-'),
            );
            this.openSuccessSnackBar('Les localisations de la FEB ont été exportées avec succès');
          } else {
            this.openErrorSnackBar('Aucune localisation de la FEB à exporter');
          }
        },
        error: (err) => {
          console.log(err);
          this.openErrorSnackBar("Une erreur est survenue lors de l'export des localisations de la FEB");
        },
        complete: () => {
        }
      });
    }
}
